<script setup lang="ts">

import { Data } from '@/stores/data'
import DocumentsItem from './item/DocumentsItem.vue'
var def = defineProps({
  backText: {
    type: [Object],
    default: {},
  },
});
const $emit = defineEmits([
  'upLoadClick',
])
//loadingState  1加载中 2 成功  3 失败
let imgUrl = Data.userInfo.value?.headimgurl ? Data.userInfo.value?.headimgurl : 'https://static.yipigai.cn/theme/20240722191033_57291.png';

// let imgUrl = Data.isReg.value ? window.xh_wen_data.url : 'https://ikeben.cn/chat/web/public/img/my-head.png';
function getUploadQ() {
  if (def.backText.text) {
    return def.backText.text
  }
  if (def.backText.upDataId && def.backText.upDataId?.data[0]?.text) {
    return def.backText.upDataId.data[0].text
  }
  // if (Data.newDownList.value[Data.currMode.value]&& Data.newDownList.value[Data.currMode.value].uploadQ) {
  //     return Data.newDownList.value[Data.currMode.value].uploadQ
  // }
  return "整理文档的核心内容"

}
function upLoadClick(pdfUrl: any) {
  // $emit('upLoadClick')
  $emit('upLoadClick', pdfUrl);
}
</script>

<template>
  <div class="mess-ctr" v-if="backText?.upDataId?.data">
    <!-- <div class="wd-text-ctr"> -->
    <div class="text-ctr">
      {{ getUploadQ() }}
    </div>
    <div class="cro">
      <div class="cro_left_top"></div>
    </div>
    <div class="avatar">
      <img class="rounded-circle" :src="imgUrl" alt="avatar">
    </div>
    <!-- </div> -->



  </div>
  <div class="wd-ctr-mess-ctr" v-if="backText?.upDataId?.data && Array.isArray(backText?.upDataId?.data)">
    <div v-for="(file, index) in backText?.upDataId.data">
      <DocumentsItem :backText="file" @upLoadClick="upLoadClick" :width="180"></DocumentsItem>
    </div>
  </div>
</template>

<style scoped lang="scss">
.wd-ctr-mess-ctr {
  display: flex;
  justify-content: flex-end;
  padding: 0 18px 14px 10%;
  flex-wrap: wrap;
  /* width: 1.56rem; */
  /* flex-direction: row; */
  gap: 4px;

}

.cro {
  transform: rotate(180deg);
  background-color: #9687fa;
}

.mess-ctr {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 2px 0 8px 10%;
  overflow: hidden;
  -webkit-animation: msgRight .5s ease-in-out;
  animation: msgRight .5s ease-in-out;
  font-size: 16px;
}

.rounded-circle {
  display: block;
}

.avatar {
  min-width: 35px;
  min-height: 35px;
  border-radius: 30px;
  overflow: hidden;

  height: 35px;
  width: 35px;
  flex-shrink: 0;
}

.text-ctr {
  // white-space: pre-wrap;
  // background: #FFDE9C;
  // border-radius: 20px 0px 20px 20px;
  // padding: 6px 12px;
  // max-width: calc(100% - 35px);
  // box-sizing: border-box;
  // /* margin-right: 6px; */
  // line-height: 24px;
  // overflow: hidden;


  word-wrap: break-word;
  white-space: pre-wrap;
  background: linear-gradient(270deg, #9786FA 0%, #898FFA 100%);
  border-radius: 16px 0px 16px 16px;
  //max-width: calc(100% - 35px);
  // max-width: 279px;
  min-width: 0;
  box-sizing: border-box;
  /* margin-right: 0.06rem; */
  line-height: 24px;
  overflow: hidden;
  color: #FFFFFF;
  padding: 12px;

}
</style>